module.exports = __webpack_public_path__ + "Roboto-MediumItalic.f10d1f42838680a70ac2.woff2";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/roboto-fontface/fonts/roboto/Roboto-MediumItalic.woff2
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-MediumItalic.woff2
// module chunks = styles